export interface TriggerDef {
  value: string;
  label: string;
  description: string;
  requiredFlag?: string;       // subscription flag required
  contextHints: string[];      // available <<ctx.*>> variables for this trigger
}

export const TRIGGER_TYPES: TriggerDef[] = [
  {
    value: "conversation_ended",
    label: "Conversation Ended",
    description: "Fires when a chat conversation ends. Great for CSAT follow-ups and 'did we help?' sequences.",
    contextHints: ["ctx.conversationId", "ctx.agentName", "ctx.channel", "ctx.duration"],
  },
  {
    value: "conversation_negative_sentiment",
    label: "Negative Sentiment Detected",
    description: "Fires when AI scores a conversation as negative. Send an apology, escalation offer, or recovery discount.",
    requiredFlag: "EnableAI",
    contextHints: ["ctx.conversationId", "ctx.agentName", "ctx.sentimentScore", "ctx.channel"],
  },
  {
    value: "contact_created",
    label: "New Contact Created",
    description: "Fires when a new contact is added — from any channel. Good for welcome sequences.",
    contextHints: ["ctx.source", "ctx.channel"],
  },
  {
    value: "contact_tag_added",
    label: "Tag Added to Contact",
    description: "Fires when a specific tag is added to a contact — great for 'Hot Lead', 'VIP', or 'At Risk' automations.",
    contextHints: ["ctx.tagName", "ctx.tagId", "ctx.source"],
  },
  {
    value: "csat_negative",
    label: "Negative CSAT Received",
    description: "Fires when a visitor rates a conversation 1 or 2 stars. Automatically sends a recovery or apology sequence.",
    requiredFlag: "EnableCsat",
    contextHints: ["ctx.rating", "ctx.comment", "ctx.agentName", "ctx.conversationId"],
  },
  {
    value: "appointment_booked",
    label: "Appointment Booked",
    description: "Fires when a visitor books via Outlook Calendar or Calendly. Send a confirmation sequence, prep materials, or a day-before reminder.",
    contextHints: ["ctx.provider", "ctx.title", "ctx.startTime", "ctx.eventId"],
  },
  {
    value: "csat_negative",
    label: "Negative CSAT (1–2 stars)",
    description: "Fires automatically when a visitor rates a chat 1 or 2 stars. Send an apology, offer escalation, or a recovery discount.",
    contextHints: ["ctx.rating", "ctx.comment", "ctx.conversationId", "ctx.channel"],
  },
  {
    value: "webhook",
    label: "Form / Webhook",
    description: "Your form, trial signup page, or any external tool POSTs to a unique URL. Fires instantly. Works with Zapier, Make.com, or a plain HTML form.",
    contextHints: ["ctx.webhook_trigger", "ctx.contact_name"],
  },
  {
    value: "trial_started",
    label: "Trial Started",
    description: "Fires when a contact starts a free trial. Send a welcome + onboarding drip to maximise activation.",
    contextHints: ["ctx.plan", "ctx.trialEndsAt"],
  },
  {
    value: "manual_enroll",
    label: "Manual Enroll",
    description: "No automatic trigger — enroll contacts manually or via API. Use for one-off campaigns.",
    contextHints: [],
  },
];

// Phase 2 triggers (not yet active — shown as coming soon)
export const COMING_SOON_TRIGGERS: TriggerDef[] = [
  { value: "ticket_created",   label: "Ticket Created",      description: "Requires ticketing feature.", requiredFlag: "EnableTicketing", contextHints: [] },
  { value: "ticket_resolved",  label: "Ticket Resolved",     description: "Requires ticketing feature.", requiredFlag: "EnableTicketing", contextHints: [] },
  { value: "nps_submitted",    label: "NPS Score Submitted",  description: "Requires NPS feature.",       requiredFlag: "EnableNPS",       contextHints: [] },
  { value: "payment_failed",   label: "Payment Failed",       description: "Requires billing.",           contextHints: [] },
];

export const GLOBAL_VARIABLES = [
  { token: "<<contact.name>>",        label: "Contact full name" },
  { token: "<<contact.firstName>>",   label: "Contact first name" },
  { token: "<<contact.email>>",       label: "Contact email" },
  { token: "<<site.name>>",           label: "Your company name" },
  { token: "<<current.date>>",        label: "Today's date" },
];
